<template>
    <div class="main-cnt ex-has-btm" style="margin-top: 40px;">
        <div class="block-cnt">
            <div class="heading-breadcrumb">{{ $t('voucher.sp_bread.contract') }}</div>
            <div class="contract-block">
                <div class="head">旅行契約</div>
                <div class="travel-contract">
                    <button class="btn-contract" @click="viewContracts(Constants.BeforeContractScreenType)">
                        <i class="icon-before-contract"></i>
                        <div style="font-size: 20px">契約書類</div>一覧
                    </button>
                    <button class="btn-contract" @click="viewContracts(Constants.AfterContractScreenType)">
                        <i class="icon-change-contract"></i>
                        <div style="font-size: 20px">変更書類</div>一覧
                    </button>
                    <button class="btn-contract" @click="viewContracts(Constants.ConfirmContractScreenType)">
                        <i class="icon-confirm-contract"></i>
                        <div style="font-size: 20px">確定書類</div>一覧
                    </button>
                </div>

                <div class="head">業務委託契約</div>
                <div class="sub-contract">
                    <button class="btn-subcontract" @click="viewSubContracting(Constants.VoucherType.contract_outsourcing.id)">
                        <i class="icon-sub-contract"></i>
                        <div style="font-size: 20px">業務委託</div>契約書
                    </button>
                    <button class="btn-subcontract"  @click="viewSubContracting(Constants.VoucherType.change_contract.id)">
                        <i class="icon-change-sub-contract "></i>
                        <div style="font-size: 20px">変更</div>契約書
                    </button>
                </div>

                <div class="head">事業パートナーとの再委託契約書</div>
                <div class="partner-contract">
                    <button class="btn-partner" @click="viewSubContracting(Constants.VoucherType.partner_contract.id)">
                        <i class="icon-partner-contract"></i>
                        <div style="font-size: 20px">再委託</div>契約書
                    </button>
                </div>

                <div class="other">
                    <button class="btn-other" @click="viewSubContracting(Constants.VoucherType.contract_other.id)">
                        <i class="icon-other-contract"></i>
                        <div style="font-size: 20px">その他</div>契約書
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Constants } from "@/helpers/constants";
import Utils from '@/helpers/utils';
import StorageService from '@/services/common/storage.service';


export default {
    components: {},
    name: "SpSelectContract",
    data () {
        return {
            Constants: Constants,
        };
    },
    methods: {
        viewContracts (screenType) {
            const tourInfo = StorageService.getTour();
            if (Utils.isEmptyObj(tourInfo)) {
                this.$toasted.error(this.$t('error.not_tour'), {icon: 'fa-exclamation-triangle'});
                return;
            }

            this.$router.push({path: '/voucher/contracts', query:{ screenType: screenType }});
        },
        viewSubContracting(voucherTypeId) {
            if (voucherTypeId == Constants.VoucherType.contract_outsourcing.id) {
                this.$router.push({path: '/voucher/subContracts', query:{ screenType: 1 }});
            } else if (voucherTypeId == Constants.VoucherType.change_contract.id) {
                this.$router.push({path: '/voucher/subContracts', query:{ screenType: 2 }});
            } else if (voucherTypeId == Constants.VoucherType.contract_other.id) {
                this.$router.push({path: '/voucher/subContracts', query:{ screenType: 3 }});
            } else if (voucherTypeId == Constants.VoucherType.partner_contract.id) {
                this.$router.push({path: '/voucher/subContracts', query:{ screenType: 4 }});
            };
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Voucher/SelectContract.vue